module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-seasons/e-novel-seasons.component.css
// module id = ./src/app/E-novels/e-novel-seasons/e-novel-seasons.component.css
// module chunks = main